/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable jsx-a11y/anchor-is-valid  */
import React, { useEffect, useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink, generatePath, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ConfigContext from 'app/context/config';
import useUrlParams from 'app/hooks/useUrlParams';
import { onHoverBehavior, onClickBehavior } from 'app/utils';
import { useConfig, useUtils } from 'app/hooks';
import { Modal, Svg } from 'app/components';
import useModal from 'app/hooks/useModal';
import { NavTag, SearchLink, NavList, NavListItem, SubList, SubListItem } from './styles';
import { useFontSize } from 'app/context/FontSizeRoute';
import { linkTo, withUTM } from 'utils';
import { generateUniqueId } from 'utils';

const propTypes = {
  cinemas: PropTypes.arrayOf(PropTypes.object).isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  savedLocation: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  // userName: PropTypes.string.isRequired
};

const BlockNav = ({ cinemas, locations, savedLocation, isLoggedIn }) => {
  const [t, i18n] = useTranslation();
  const { routes, country, showingOptions } = useContext(ConfigContext);
  const { date } = useUrlParams('date');
  const [cinemasToShow, setCinemas] = useState([]);
  const {
    streamingUrl,
    giftCardShopEN,
    giftCardShopDE,
    vodNotLoggedInUrlEN,
    vodNotLoggedInUrlDE
  } = useConfig();
  // eslint-disable-next-line no-unused-vars
  const [streamingFunction, showStreamingFunction, hideStreamingFunction] = useModal('Streaming');
  const refreshToken = localStorage.getItem('refreshToken');
  const streamingUrlSet = `${streamingUrl}?refresh_token=${refreshToken}`;
  const { getFallbackDate } = useUtils();
  const countryCode = process.env.REACT_APP_COUNTRY;
  const { fontSize, increaseFontSize, decreaseFontSize, resetFontSize } = useFontSize();

  const accessToken = localStorage.getItem('accessToken');


  const clubList = useMemo(
    () => [
      {
        id: 1,
        label: 'bonusCard',
        name: t('common.bonus_card'),
        route: routes.bonusCardInfo.pattern
      },
      {
        id: 2,
        label: 'familyFilmclub',
        name: t('common.family_film_club'),
        route: routes.familyFilmClub.pattern
      },
      {
        id: 3,
        label: 'competitions',
        name: t('common.competitions'),
        route: routes.competitionInfo.pattern
      }
    ],
    [t]
  );

  const giftcardList = useMemo(
    () => [
      {
        id: 1,
        label: 'giftcardShop',
        name: t('common.giftcard_shop'),
        route: routes.bonusCardInfo.pattern
      },
      {
        id: 2,
        label: 'giftcardInfo',
        name: t('common.giftcard_info'),
        route: routes.giftCardInfo.pattern
      }
    ],
    [t]
  );

  const NavListProps = useMemo(
    () => ({
      ...(country !== 'aut' && onHoverBehavior),
      ...(country !== 'aut' && { chevron: true })
    }),
    [country, onHoverBehavior]
  );

  useEffect(() => {
    if (savedLocation === 'all') {
      setCinemas(cinemas);
    } else {
      /* eslint-disable no-param-reassign */
      const items = locations.reduce((res, l) => {
        if (l.id.toString() === savedLocation) {
          res = l.items;
        }

        return res;
      }, []);
      /* eslint-enable no-param-reassign */

      if (items.length) {
        setCinemas(cinemas.filter(c => items.some(i => i.toString() === c.id)));
      }
    }
  }, [locations, cinemas, savedLocation, fontSize]);


  const toTitleCase = (str) => {
    if (!str) return str;

    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  return (
    <NavTag>
      <NavList>
        <Modal
          isOpen={streamingFunction}
          close={hideStreamingFunction}
          title="Streaming"
        >
          <h3>{t('common.streaming_condition')}</h3>
        </Modal>
        <NavListItem isLoggedIn={accessToken} fontSize={fontSize} id={`footer-contacts-link-${generateUniqueId()}`} >
          <NavLink
            to={withUTM({
              pathname: routes.movies.pattern,
              search: `?category=now&location=${savedLocation}${date ? `&date=${date}` : ''}`
            })}
            activeClassName="_active"
            exact
            id={`header-nav-item-${generateUniqueId()}`}
          >
            {t('common.movies')}
          </NavLink>
        </NavListItem>
        <NavListItem isLoggedIn={accessToken} fontSize={fontSize} id={`header-nav-navListItem-${generateUniqueId()}`}>
          <NavLink
            to={withUTM({
              pathname: routes.events.pattern,
              search: `?location=${savedLocation}&date=all`
            })}
            activeClassName="_active"
            exact
            id={`header-nav-item-${generateUniqueId()}`}
          >
            {t('common.events')}
          </NavLink>
        </NavListItem>
        <NavListItem {...NavListProps} isLoggedIn={accessToken} fontSize={fontSize} id={`header-nav-navListItem-${generateUniqueId()}`}>
          <NavLink
            to={withUTM({
              pathname: routes.cinemas.pattern,
              search: `?location=${savedLocation}${(date === 'all' || date === undefined) ? `&date=${getFallbackDate([])}` : `&date=${date}`}`
            })}
            activeClassName="_active"
            exact
            id={`header-nav-item-${generateUniqueId()}`}
          >
            {t('common.cinemas')}
          </NavLink>
        </NavListItem>
        {(!showingOptions?.club?.bonusCard && !showingOptions?.club?.familyFilmClub && !showingOptions?.club?.competitions) ? null : showingOptions?.member && (
          <NavListItem {...onHoverBehavior} chevron isLoggedIn={accessToken} fontSize={fontSize} id={`header-nav-navListItem-${generateUniqueId()}`}>
            <NavLink
              to={linkTo(routes.bonusCardInfo.pattern)}
              activeClassName="_active"
              exact
              id={`header-nav-item-${generateUniqueId()}`}
            // className="_with-chevron"
            >
              {t('common.club')}
            </NavLink>
            <SubList fontSize={fontSize} >
              {clubList.map(
                ({ id, label, name, route }) =>
                  showingOptions?.club?.[label] && (
                    <SubListItem key={id} {...onClickBehavior} id={`header-nav-subListItem-${generateUniqueId()}`}>
                      <NavLink
                        className="l-sublist__link"
                        to={withUTM({
                          pathname: generatePath(route)
                        })}
                        activeClassName="_active"
                        exact
                        id={`header-nav-subMenu-${generateUniqueId()}`}
                      >
                        {/* {toTitleCase(name)} */}
                        {name}
                      </NavLink>
                    </SubListItem>
                  )
              )}
            </SubList>
          </NavListItem>
        )}
        {(!showingOptions?.giftCards?.giftcardShop && !showingOptions?.giftCards?.giftcardInfo) ? null : showingOptions?.giftcards && (
          <NavListItem {...onHoverBehavior} chevron isLoggedIn={accessToken} fontSize={fontSize} id={`header-nav-navListItem-${generateUniqueId()}`}>
            <a href={i18n.language === 'en' || i18n.language === 'en-US' ? giftCardShopEN : giftCardShopDE}
              // className="_with-chevron"
              activeClassName="_active"
              id={`header-nav-item-${generateUniqueId()}`}>
              {t('common.giftcards')}
            </a>
            <SubList>
              {giftcardList.map(
                ({ id, label, name, route }) =>
                  showingOptions?.giftCards?.[label] && (
                    <SubListItem key={id} {...onClickBehavior} id={`header-nav-subListItem-${generateUniqueId()}`}>
                      {name === t('common.giftcard_shop') ? (
                        <a
                          href={i18n.language === 'en' || i18n.language === 'en-US' ? giftCardShopEN : giftCardShopDE}
                          className="l-sublist__link"
                          activeClassName="_active"
                          exact="true"
                          id={`header-nav-subMenu-${generateUniqueId()}`}
                        >
                          {name}
                        </a>
                      ) : (
                        <NavLink
                          className="l-sublist__link"
                          to={withUTM({
                            pathname: generatePath(route)
                          })}
                          activeClassName="_active"
                          exact
                          id={`header-nav-item-${generateUniqueId()}`}
                        >
                          {name}
                        </NavLink>
                      )}
                    </SubListItem>
                  )
              )}
            </SubList>
          </NavListItem>
        )}
        {showingOptions?.cinemaRent && (
          <NavListItem isLoggedIn={accessToken} fontSize={fontSize} id={`header-nav-navListItem-${generateUniqueId()}`}>
            <NavLink
              to={linkTo(routes.cinemaRent.pattern)}
              activeClassName="_active"
              exact
              id={`header-nav-item-${generateUniqueId()}`}
            >
              {t('common.cinema_rent')}
            </NavLink>
          </NavListItem>
        )}
        {countryCode === 'aut' && (
          <NavListItem isLoggedIn={accessToken} fontSize={fontSize}>
            <NavLink
              to={{
                pathname: routes.opera.pattern
              }}
              activeClassName="_active"
              exact
            >
              {t('common.opera')}
            </NavLink>
          </NavListItem>
        )}
        {showingOptions?.streaming && (
          <NavListItem isLoggedIn={accessToken} fontSize={fontSize} id={`header-nav-navListItem-${generateUniqueId()}`}>
            {isLoggedIn ?
              <a
                activeClassName="_active"
                exact="true"
                href={streamingUrlSet}
                id={`header-nav-item-${generateUniqueId()}`}
              >
                {t('common.streaming')}
              </a>
              : <a
                activeClassName="_active"
                exact="true"
                href={i18n.language === 'en' ? vodNotLoggedInUrlEN : vodNotLoggedInUrlDE}
                id={`header-nav-item-${generateUniqueId()}`}
              >
                {t('common.streaming')}
              </a>
            }
          </NavListItem>
        )}

        <NavListItem fontSize={fontSize}>
          <SearchLink
            to={withUTM(routes.faq.pattern)}
            activeClassName="_active"
            isLoggedIn={accessToken}
            aria-label="contact"
          >
            <Svg id="contact" aria-hidden="true" tabIndex="0" />
          </SearchLink>
        </NavListItem>

        <NavListItem>
          <button className="zoom-buttons" onClick={increaseFontSize}>+A</button>
        </NavListItem>

        <NavListItem>
          <button className="zoom-buttons" onClick={resetFontSize}>A</button>
        </NavListItem>

        <NavListItem >
          <button className="zoom-buttons" onClick={decreaseFontSize}>-A</button>
        </NavListItem>
      </NavList>
    </NavTag >
  );
};

BlockNav.propTypes = propTypes;
export default BlockNav;
